import { IsEnum, IsOptional, MinLength } from 'class-validator';

import { EventStatusEnum } from '@onArte/shared/enums';
import { ListQuery } from '@onArte/shared/models/common';

export class EventsManagementListQuery extends ListQuery {
  @IsOptional()
  @IsEnum(EventStatusEnum)
  public status?: EventStatusEnum;

  @IsOptional()
  @MinLength(1)
  public search?: string;

  constructor(
    limit?: number,
    offset?: number,
    status?: EventStatusEnum,
    search?: string,
  ) {
    super(limit, offset);

    this.status = status;
    this.search = search;
  }

}
